import { Link } from "gatsby"
import React from "react"
import PropTypes from "prop-types"
import styles from "./articlePreview.module.css"
import SmallArrowIcon from "./svg/smallArrowIcon"
const { getLinkToArticleByArticleTitle } = require("../scripts/articlesScripts")

export default function ArticlePreview({
  className,
  imgLink,
  header,
  description,
  category,
  date,
  articleLink,
  articleInformationClassName,
}) {
  const articlePublishDate = new Date(date)
  const articlePublishMonthString = articlePublishDate
    .toLocaleString("en-US", { month: "long" })
    .toLowerCase()

  const articlePublishDateString = `${articlePublishDate.getDate()} ${articlePublishMonthString} ${articlePublishDate.getFullYear()}`

  return (
    // <Link to={articleLink}>
    <Link to={getLinkToArticleByArticleTitle(header)}>
      <div className={`${styles.wrapper} ${className}`}>
        <img className={styles.articleImage} src={imgLink} alt={header} />
        <div
          className={`${styles.articleInformation} ${articleInformationClassName}`}
        >
          <button className={styles.linkButton}>
            <SmallArrowIcon className={styles.arrow} />
          </button>
          <h3>{header}</h3>
          {description && (
            <p className={styles.articleDescription}>{description}</p>
          )}
          {category && date && (
            <p className={styles.articleSecondaryInformation}>
              <span className={styles.articleCategory}>{category}</span>
              <span className={styles.articleDate}>
                {articlePublishDateString}
              </span>
            </p>
          )}
        </div>
      </div>
    </Link>
  )
}

ArticlePreview.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  imgLink: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  description: PropTypes.string,
  category: PropTypes.string,
  date: PropTypes.string,
  articleLink: PropTypes.string.isRequired,
  articleInformationClassName: PropTypes.string,
}

ArticlePreview.defaultProps = {
  className: "",
}
